import React, {FC, useEffect, useRef, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, getEncryptedRoute, handleTimeChange, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddRestaurantHeader} from './AddRestaurantHeader'
import moment from 'moment'
import Flatpickr from 'react-flatpickr'
import {Tr} from '../../../_metronic/i18n/Tr'

const AddRestaurantPolicies: FC = () => {
  let t = Tr()
  const location = useLocation()
        const {menuId} = useMenuIdPermissions()

  const editRestaurantId = (location.state as any)?.restaurantId || ''
  const primaryLanguage = sessionStorage.getItem('primaryLanguage')
  const [restaurantDetails, setRestaurantDetails] = useState([])

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const navigate = useNavigate()
  const restaurantId = sessionStorage.getItem('restaurantId') || ''

  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [additionalInformationEN, setAdditionalInformationEN] = useState('')
  const [additionalInformationRU, setAdditionalInformationRU] = useState('')
  const [additionalInformationUZ, setAdditionalInformationUZ] = useState('')
  const [showPolicy, setShowPolicy] = useState(false)

  const togglePolicy = () => {
    setShowPolicy(!showPolicy)
  }

  const [policies, setPolicies] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
    },
  ])

  // set error state
  const [error, setError] = useState([
    {
      additionalInformationEN: '',
      additionalInformationRU: '',
      additionalInformationUZ: '',
    },
  ])

  const [errors, setErrors] = useState({
    titleEN: '',
    titleRU: '',
    titleUZ: '',
    descriptionEN: '',
    descriptionRU: '',
    descriptionUZ: '',
  }) as any

  const handleAddPolicy = () => {
    setPolicies([
      ...policies,
      {
        en_title: '',
        ru_title: '',
        uz_title: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
      },
    ])
  }

  const handleRemovePolicy = (index: any) => {
    if (policies.length === 1) return // Prevent removing the last row
    const updatedPolicies = policies.filter((_, i) => i !== index)
    setPolicies(updatedPolicies)
    // Clear errors for removed policy
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  const handlePolicyChange = (index: any, field: any, value: any) => {
    const updatedPolicies = [...policies] as any
    updatedPolicies[index][field] = value
    setPolicies(updatedPolicies)
    // Clear error when user starts typing
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }
  function getDayNumber(day: any) {
    switch (day.toLowerCase()) {
      case 'monday':
        return 1
      case 'tuesday':
        return 2
      case 'wednesday':
        return 3
      case 'thursday':
        return 4
      case 'friday':
        return 5
      case 'saturday':
        return 6
      case 'sunday':
        return 7
      default:
        return 0 // For any other case
    }
  }
  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        additionalInformationEN.trim() == '' ||
        additionalInformationEN.trim() == null ||
        additionalInformationEN.trim() == undefined
      ) {
        errorTmp[0].additionalInformationEN = t('Additional Information Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        additionalInformationRU.trim() == '' ||
        additionalInformationRU.trim() == null ||
        additionalInformationRU.trim() == undefined
      ) {
        errorTmp[0].additionalInformationRU = 'Additional Information Is Required'
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        additionalInformationUZ.trim() == '' ||
        additionalInformationUZ.trim() == null ||
        additionalInformationUZ.trim() == undefined
      ) {
        errorTmp[0].additionalInformationUZ = 'Additional Information Is Required'
        isValid = false
      }
    }

    if (showPolicy) {
      const newErrors = {} as any
      policies.forEach((policy: any, index: any) => {
        if (primaryLanguage == 'English') {
          if (!policy.en_title) {
            newErrors[index] = {...newErrors[index], titleEN: t('Policy Title Is Required')}
            isValid = false
          }

          if (!policy.en_description) {
            newErrors[index] = {...newErrors[index], descriptionEN: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Russian') {
          if (!policy.ru_title) {
            newErrors[index] = {...newErrors[index], titleRU: t('Policy Title Is Required')}
            isValid = false
          }

          if (!policy.ru_description) {
            newErrors[index] = {...newErrors[index], descriptionRU: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Uzbek') {
          if (!policy.uz_title) {
            newErrors[index] = {...newErrors[index], titleUZ: t('Policy Title Is Required')}
            isValid = false
          }

          if (!policy.uz_description) {
            newErrors[index] = {...newErrors[index], descriptionUZ: t('Description Is Required')}
            isValid = false
          }
        }
      })
      setErrors(newErrors)
    }

    setError(errorTmp)

    return isValid
  }

  // const [openingHourData, setOpeningHourData] = useState([
  //     { day: 'MONDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'TUESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'WEDNESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'THURSDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'FRIDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SATURDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SUNDAY', timeSlot: [{ startTime: '', endTime: '' }] }
  // ]);

  const [openingHourData, setOpeningHourData] = useState([
    {day: 'MONDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'TUESDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'WEDNESDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'THURSDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'FRIDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'SATURDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
    {day: 'SUNDAY', isOpen: '0', timeSlot: [{startTime: '00:00:00', endTime: '00:00:00'}]},
  ])

  // const addTimeField = (index:any) => {
  //     const newData = [...openingHourData];
  //     newData[index].timeSlot.push({ startTime: '', endTime: '' });
  //     setOpeningHourData(newData);
  // };

  // const addTimeField = (index: any) => {
  //   const newData = [...openingHourData]
  //   newData[index].timeSlot.push({startTime: '00:00:00', endTime: '00:00:00'})
  //   setOpeningHourData(newData)
  // }

  const addTimeField = (index: number) => {
    const newData = [...openingHourData]

    // If currently closed (no time slots), set isOpen to '1'
    if (newData[index].timeSlot.length === 0) {
      newData[index].isOpen = '1'
    }

    newData[index].timeSlot.push({startTime: '00:00:00', endTime: '00:00:00'})
    setOpeningHourData(newData)
  }

  // const removeTimeField = (dayIndex: any, timeIndex: any) => {
  //   const newData = [...openingHourData]
  //   newData[dayIndex].timeSlot.splice(timeIndex, 1)
  //   setOpeningHourData(newData)
  // }

  const removeTimeField = (dayIndex: number, timeIndex: number) => {
    setOpeningHourData((prev: any) => {
      const newData = [...prev]
      newData[dayIndex].timeSlot.splice(timeIndex, 1)

      // If no time slots left, set isOpen to '0'
      if (newData[dayIndex].timeSlot.length == 0) {
        newData[dayIndex].isOpen = '0'
      }

      return newData
    })
  }

  const handleInputChange = (dayIndex: any, timeIndex: any, event: any) => {
    const {name, value} = event.target
    const parsedTime = moment(value, 'HH:mm')
    // Format the time as HH:mm:ss
    let formattedValue = parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : ''
    const newData = [...openingHourData] as any
    // Validate start time against end time
    if (name === 'startTime') {
      const endTime = newData[dayIndex].timeSlot[timeIndex].endTime
      if (endTime && formattedValue >= endTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    } else if (name === 'endTime') {
      const startTime = newData[dayIndex].timeSlot[timeIndex].startTime
      // If endTime is entered as 00:00, replace with 23:45
      if (formattedValue == '00:00:00') {
        formattedValue = '23:45:00'
      }
      if (startTime && formattedValue <= startTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    }
    // Validate time conflicts
    for (let i = 0; i < newData[dayIndex].timeSlot.length; i++) {
      if (i !== timeIndex) {
        const existingStartTime = newData[dayIndex].timeSlot[i].startTime
        const existingEndTime = newData[dayIndex].timeSlot[i].endTime
        if (
          (formattedValue >= existingStartTime && formattedValue < existingEndTime) ||
          (existingStartTime >= formattedValue && existingStartTime < formattedValue)
        ) {
          toasterrormsg('Time Is Conflicting')
          return
        }
      }
    }
    newData[dayIndex].timeSlot[timeIndex][name] = formattedValue
    setOpeningHourData(newData)
  }

  // Check if any required fields are not defined or empty
  const isValid = openingHourData.every((opening) => {
    return opening.day && opening.timeSlot.every((slot) => slot.startTime && slot.endTime)
  })
  // add hotel policy api call
  const addRestaurantPolicies = async () => {
    if (validate()) {
      if (isValid) {
        setDisable(true)
        setLoading(true)

        var param: any = {
          restaurantId: String(editRestaurantId),
          en_additionalInformation: additionalInformationEN,
          ru_additionalInformation: additionalInformationRU,
          uz_additionalInformation: additionalInformationUZ,
          openinghours: openingHourData,
        }
        if (showPolicy) {
          param['customPolicy'] = policies
        }

        var response: any = await fetchData('vendor/public/addRestaurantPolicy', param)

        if (response.status == '200') {
          toastsuccessmsg('Policies Added Successfully!')
          const state = {
            restaurantId: editRestaurantId,
          }
          setTimeout(() => {
                                          navigate(getEncryptedRoute('../addrestaurantfinance/', {menuId:menuId}), {state})

            setDisable(false)
          }, 1500)
        } else {
          toasterrormsg(response.message)
          setDisable(false)
          setLoading(false)
        }
      } else {
        toasterrormsg('Please fill in all required fields.')
        setLoading(false)
        return
      }
    }
  }
  //   restaurant list api call
  const restaurantListAPIcall = async () => {
    var param = {
      restaurantId: editRestaurantId,
    }
    var res = await fetchData('vendor/public/restaurantDetail', param)

    if (res.status == '200') {
      var restaurantData = res.data
      setRestaurantDetails(restaurantData)
      setAdditionalInformationEN(restaurantData[0]['en_additionalInformation'])
      setAdditionalInformationRU(restaurantData[0]['ru_additionalInformation'])
      setAdditionalInformationUZ(restaurantData[0]['uz_additionalInformation'])
      if (restaurantData[0]['openingHours'].length != 0) {
        var openingHours = restaurantData[0]['openingHours'].map((item: any) => {
          return {
            openinghourId: item.openinghourId,
            day: item.day,
            isOpen: item.timeSlot.length > 0 ? '1' : '0',
            timeSlot: item.timeSlot,
          }
        })
        // Sort the opening hours based on the day of the week
        openingHours.sort((a: any, b: any) => {
          return getDayNumber(a.day) - getDayNumber(b.day)
        })
        setOpeningHourData(openingHours)
      }
      if (restaurantData[0]['customPolicy'].length != 0) {
        setShowPolicy(true)
        setPolicies(restaurantData[0]['customPolicy'])
      }
    } else {
      toasterrormsg(res.message)
    }
  }
  useEffect(() => {
    if (editRestaurantId != '') {
      restaurantListAPIcall()
    }
  }, [])

  const toggleDayOpen = (dayIndex: number) => {
    setOpeningHourData((prev: any) =>
      prev.map((day: any, index: number) => {
        if (index === dayIndex) {
          const newIsOpen = day.isOpen === '1' ? '0' : '1'
          return {
            ...day,
            isOpen: newIsOpen,
            timeSlot:
              newIsOpen === '1'
                ? [{startTime: '00:00:00', endTime: '00:00:00'}] // open → add default slot
                : [], // close → clear all slots
          }
        }
        return day
      })
    )
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editRestaurantId != '' ? t('Edit Policies') : t('Add Policies')}
      </PageTitle>
      <AddRestaurantHeader restaurantId={editRestaurantId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Policies')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {restaurantDetails.length != 0 ? (
                            <>
                              {restaurantDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['menu']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {primaryLanguage == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Additional Information (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationEN'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationEN(e.target.value)
                                    removeError('additionalInformationEN')
                                  }}
                                  value={additionalInformationEN}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].additionalInformationEN}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationRU'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationRU(e.target.value)
                                  }}
                                  value={additionalInformationRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationUZ(e.target.value)
                                  }}
                                  value={additionalInformationUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Additional Information (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationRU'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationRU(e.target.value)
                                    removeError('additionalInformationRU')
                                  }}
                                  value={additionalInformationRU}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].additionalInformationRU}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationEN'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationEN(e.target.value)
                                  }}
                                  value={additionalInformationEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationUZ(e.target.value)
                                  }}
                                  value={additionalInformationUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Additional Information (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationUZ(e.target.value)
                                    removeError('additionalInformationUZ')
                                  }}
                                  value={additionalInformationUZ}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].additionalInformationUZ}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationRU'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationRU(e.target.value)
                                  }}
                                  value={additionalInformationRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Additional Information (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='additionalInformationEN'
                                  className='form-control mb-2'
                                  placeholder={t('Additional Information')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setAdditionalInformationEN(e.target.value)
                                  }}
                                  value={additionalInformationEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        <div className='row'>
                          <div className='border border-2'></div>
                          <div className='col-lg-12 my-3'>
                            <label className='fs-3 form-label fw-bold'>{t('Opening Hours')}</label>
                          </div>
                          <div className='col-lg-12 '>
                            <span className='fw-bolder fs-5 form-label'>
                              *Note{' '}
                              <span className='fs-6 form-label'>
                                {' '}
                                {t(`If you don't add "opening hours" to any days of the week below, that
                                day will be considered as "Closed", "Unavailable for bookings`)}
                              </span>
                            </span>
                          </div>
                        </div>
                        {/* <!--begin::Row--> */}
                        {openingHourData.map((dayData, dayIndex) => (
                          <div className='row mb-4' key={dayIndex}>
                            <div className='col-12 col-lg-2 mb-3 d-flex justify-content-between align-items-center'>
                               <h5 className='mb-0'>
                                {t(dayData.day.charAt(0).toUpperCase() + t(dayData.day).slice(1).toLowerCase())}
                              </h5>
                            </div>

                            <div className='col-12 col-lg-2 mb-3'>
                              <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                                <input
                                  className='form-check-input cursor-pointer'
                                  type='checkbox'
                                  id={`flexSwitchCheckDefault${dayIndex}`}
                                  checked={dayData.isOpen === '1'}
                                  onChange={() => toggleDayOpen(dayIndex)}
                                />
                                <label
                                  className='form-check-label text-gray-700 fw-bold ms-2'
                                  htmlFor={`flexSwitchCheckDefault${dayIndex}`}
                                  data-bs-toggle='tooltip'
                                  title={
                                    dayData.isOpen === '1' ? 'Currently Open' : 'Currently Closed'
                                  }
                                >
                                  {dayData.isOpen === '1' ? t('Open') : t('Closed')}
                                </label>
                              </div>
                            </div>

                            <div className='col-12 col-lg-8'>
                              {dayData.timeSlot.map((timeSlot, timeIndex) => (
                                <div className='row align-items-end mb-3' key={timeIndex}>
                                  <div className='col-12 col-md-5 mb-2'>
                                    <label className='fs-6 form-label required'>
                                      {t('Start Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.startTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handleInputChange(dayIndex, timeIndex, {
                                          target: {name: 'startTime', value: formattedTime},
                                        })
                                      }}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        time_24hr: true,
                                        minuteIncrement: 15,
                                        allowInput: false,
                                      }}
                                      className='form-control'
                                    />
                                  </div>

                                  <div className='col-12 col-md-5 mb-2'>
                                    <label className='fs-6 form-label required'>
                                      {t('End Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.endTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handleInputChange(dayIndex, timeIndex, {
                                          target: {name: 'endTime', value: formattedTime},
                                        })
                                      }}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        time_24hr: true,
                                        minuteIncrement: 15,
                                        allowInput: false,
                                      }}
                                      className='form-control'
                                    />
                                  </div>

                                  <div className='col-12 col-md-2 mt-2 d-flex justify-content-end justify-content-md-start'>
                                    <div className='d-flex flex-wrap gap-2'>
                                      {(dayData.timeSlot.length > 1 ||
                                        (dayData.timeSlot.length === 1 && timeIndex === 0)) && (
                                        <button
                                          className='btn btn-danger'
                                          onClick={() => removeTimeField(dayIndex, timeIndex)}
                                        >
                                          X
                                        </button>
                                      )}
                                      {timeIndex === dayData.timeSlot.length - 1 && (
                                        <button
                                          className='btn btn-success'
                                          onClick={() => addTimeField(dayIndex)}
                                        >
                                          +
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}

                        {/* <!--end::Row--> */}
                        <div className='row'>
                          <div className='border border-2'></div>
                          <div className='col-lg-12 my-3'>
                            <button className='btn btn-light-success' onClick={togglePolicy}>
                              {t('Add Custom Policy')}
                            </button>
                          </div>
                        </div>

                        {/* <!--end::Input group--> */}
                        {showPolicy &&
                          policies.map((policy, index) => (
                            <div className='row' key={index}>
                              {primaryLanguage == 'English' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>

                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Russian' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>

                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Uzbek' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label required'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>

                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addRestaurantPolicies}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddRestaurantPolicies}
